<template>
    <div class="auth-wrapper auth-v1 px-2">
      <div class="auth-inner py-2">
  
        <!-- Register v1 -->
        <b-card class="mb-0">
          <b-link class="brand-logo">
            <vuexy-logo />
            <b-icon-image src="" />
            <h2 class="brand-text text-primary ml-1">
              VSLBoster
            </h2>
          </b-link>
  
          <b-card-title class="mb-1">
            Criar sua conta
          </b-card-title>
         <pre>{{ usuario}}</pre>
          <!-- form -->
          <validation-observer ref="registerForm">
            <b-form
              class="auth-register-form mt-2"
              @submit.prevent="submitCreate()"
            >
              <!-- username -->
              <b-form-group
                label="Nome do usuário"
                label-for="username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  rules="required"
                >
                  <b-form-input
                    id="username"
                    v-model="usuario.usuario_nome"
                    :state="errors.length > 0 ? false:null"
                    name="register-username"
                    placeholder="johndoe"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
  
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="usuario.usuario_email"
                    :state="errors.length > 0 ? false:null"
                    name="register-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
  
              <!-- password -->
              <b-form-group
                label="Senha"
                label-for="password"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="password"
                      v-model="usuario.usuario_senha"
                      :type="passwordFieldType"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      name="register-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIcon"
                        class="cursor-pointer"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
  
              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="register-privacy-policy"
                  v-model="status"
                  name="checkbox-1"
                >
                  I agree to
                  <b-link>privacy policy & terms</b-link>
                </b-form-checkbox>
              </b-form-group> -->
  
              <!-- submit button -->
              <b-button
                variant="primary"
                block
                type="submit"
              >
                Inscrição
              </b-button>
            </b-form>
          </validation-observer>
  
          <b-card-text class="text-center mt-2">
            <span>Já tem uma conta? </span>
            <b-link :to="{name:'login'}">
              <span>Faça login em vez disso</span>
            </b-link>
          </b-card-text>

  
        </b-card>
      <!-- /Register v1 -->
      </div>
    </div>
  
  </template>
  
  <script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import {
    BCard, BLink, BCardTitle, BCardText, BForm,
    BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox,
  } from 'bootstrap-vue'
  import VuexyLogo from '@core/layouts/components/Logo.vue'
  import { required, email } from '@validations'
  import { togglePasswordVisibility } from '@core/mixins/ui/forms'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import { UsuarioService } from '@/services/loginService'
  export default {
    components: {
      VuexyLogo,
      // BSV
      BCard,
      BLink,
      BCardTitle,
      BCardText,
      BForm,
      BButton,
      BFormInput,
      BFormGroup,
      BInputGroup,
      BInputGroupAppend,
      BFormCheckbox,
      // validations
      ValidationProvider,
      ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
      return {
        usuario: {
            usuario_nome: "",
			usuario_email: "",
			usuario_senha: "",
            },
        status: '',
  
        // validation rules
        required,
        email,
      }
    },
    computed: {
      passwordToggleIcon() {
        return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
      },
    },
    methods: {
      validationForm() {
        this.$refs.registerForm.validate().then(success => {
          if (success) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Form Submitted',
                icon: 'EditIcon',
                variant: 'success',
              },
            })
          }
        })
      },
      submitCreate: async function () {
     
            try {
               
                let response = await UsuarioService.createUsuario(this.usuario);

                if (response) {
                    return this.$router.push('/login');
                }
                else {
                    return this.$router.push('/cadastro');

                }

            }
            catch (error) {
                console.log(error);
            }
        }
    },
    
  }
  </script>
  
  <style lang="scss">
  @import '@core/scss/vue/pages/page-auth.scss';
  </style>

